import { toast } from 'react-toastify';
import apiClient from '../utils/apiCliente';

const extractApiErrorMessage = (errorData) => {
	if (!errorData) return null;
	if (typeof errorData === 'string') {
		try {
			const parsed = JSON.parse(errorData);
			return parsed?.error || parsed?.message || errorData;
		} catch (_e) {
			return errorData;
		}
	}

	return errorData.error || errorData.message || null;
};

export const obtenerCostoEnvio = async (id, pedidoId, token) => {
	try {
		const response = await apiClient.get(
			'/direcciones/calcularCostoEnvio?direccion_id=' + id + '&pedido_id=' + pedidoId,
			{ headers: { Authorization: `Bearer ${token}` } },
		);

		return response.data;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 401) {
				toast.info('Su sesión ha expirado. Por favor, inicie sesión nuevamente.', {
					onClose: () => {
						window.location.href = '/login';
					},
				});
			} else {
				const errorData = error.response.data;
				const backendMessage = extractApiErrorMessage(errorData);
				throw new Error(backendMessage || 'Se produjo un error desconocido.');
			}
		} else if (error.request) {
			throw new Error('No se pudo establecer conexión con el servidor.');
		} else {
			throw new Error('Error al realizar la solicitud.');
		}
	}
};
